export default __webpack_public_path__ + "static/media/fiolet_wi-fi.839ef548.svg";